export default "__VITE_ASSET__3a0b6846__"